import React, { useEffect } from "react";
import M from "materialize-css/dist/js/materialize";
import useStateWithPromise from "../../utils/useEffectUpdate";
import { openCollapsible } from "../../utils/util";

const CollapsibleUI = (props) => {
    const [collapsed, setCollapsed] = useStateWithPromise();

    useEffect(() => {
        M.Collapsible.init(document.querySelectorAll(".collapsible"), {
            accordion: false,
            onOpenStart: () => {
                setCollapsed(true).then(() => {
                    if (props.onClickEvent) {
                        props.onClickEvent(props.id);
                    }
                });
            },
            onCloseStart: () => setCollapsed(false),
        });
    }, []);

    const renderActions = () => {
        let actions = [];

        if (props.onAction) {
            actions.push(
                <div key="default-action" className="col s2" style={{ padding: "1px" }}>
                    <button
                        type="button"
                        onClick={(e) => props.onAction?.(e)}
                        style={{
                            backgroundColor: "transparent",
                            border: "none",
                            cursor: "pointer",
                        }}
                    >
                        <i className={props.actionicon || 'mdi mdi-36px mdi-delete'} style={{ color: "red" }} />
                    </button>
                </div>
            );
        }

        if (props.actions) {
            props.actions.forEach((action, idx) => {
                actions.push(
                    <div key={`action-${idx}`} className="col s2">
                        <button
                            type="button"
                            onClick={(e) => {
                                if (action.open) {
                                    openCollapsible(props.id);
                                    setCollapsed(true).then(() => {
                                        action.func?.(e);
                                    });
                                } else {
                                    action.func?.(e);
                                }
                            }}
                            style={{
                                backgroundColor: "transparent",
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            <i className={action.actionicon} style={{ color: action.actionIconColor || "red" }} />
                        </button>
                    </div>
                );
            });
        }

        return actions;
    };

    const renderHeader = () => (
        <div
            className={`collapsible-header col s${props.actions || props.onAction ? 12 - ((props.actions?.length || 0) + (props.onAction ? 1 : 0)) * 2 : 12}`}
            style={{ padding: "3px" }}
        >
            <div className="flex-center" style={{ display: "flex", alignItems: "center" }}>
                <i className={`mdi mdi-menu-${collapsed ? "up" : "down"}`} />
                <b>{props.header || ""}</b>
            </div>
        </div>
    );

    return (
        <ul
            key={props.id || "..colUi"}
            {...props}
            className={`collapsible ${props.simple ? "" : "popout"}`}
        >
            <li key={`li-${props.id}` || "..li"} className={props.close ? "" : "active"}>
                <div className="row" style={{ marginBottom: '0px', backgroundColor: 'white' }}>
                    {props.actionPosition === "left" && renderActions()}
                    {renderHeader()}
                    {(!props.actionPosition || props.actionPosition === "right") && renderActions()}
                </div>
                <div
                    className="collapsible-body"
                    style={{
                        paddingBlock: "0px",
                        backgroundColor: "white",
                        padding: `${props.paddingbody ? props.paddingbody : "1rem"}`
                    }}
                >
                    {props.body}
                </div>
            </li>
        </ul>
    );
};

export default CollapsibleUI;
